// extracted by mini-css-extract-plugin
export default {"croutonText":"IoLMNm","croutonTextWithSubText":"dKciHa","croutonSubText":"Bol5uP","croutonIcon":"ixglxz","croutonPostTextEl":"e3ZlwG","croutonButton":"oBMNIg"};